import { render, staticRenderFns } from "./iFeelReportCopyA.vue?vue&type=template&id=8120b932&scoped=true&"
import script from "./iFeelReportCopyA.vue?vue&type=script&lang=js&"
export * from "./iFeelReportCopyA.vue?vue&type=script&lang=js&"
import style0 from "./iFeelReportCopyA.vue?vue&type=style&index=0&id=8120b932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8120b932",
  null
  
)

export default component.exports